import React,{useEffect, useState} from 'react'
import CalendarDateInput from '../../../../../components/AppInput/CalendarDateInput';
import attendanceServices from '../attendanceServices';
import moment from 'moment';
import { useAppData } from '../../../../../context/AppDataContext';
import CalculateHours from '../../../../../components/CalculateHours';
import { Link } from 'react-router-dom';
import UpdatePunchForm from './UpdatePunchForm';
function DailyAttendanceList() {
  const {employeeDD,getDDDataById} = useAppData()
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [attendanceList,setAttendanceList] = useState(null);

  const getAttendanceByDate = ()=>{
    attendanceServices.getAttendanceByDate( moment(selectedDate).format("YYYY-MM-DD")).then(res=>{
      setAttendanceList(res.data)
    }).catch(error=>{

    })
  }

  useEffect(()=>{
    getAttendanceByDate()
  },[selectedDate])

  return (
    <div className='row'>
      <div className='col-md-12'>
        <CalendarDateInput selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
      </div>
      <div className='col-md-12'>
        {attendanceList && 
          <table className='table table-striped'>
            <thead>
                <tr>
                  <th>Employee</th>
                  <th>In Time</th>
                  <th>OutTime</th>
                  <th>Hours</th>
                  <th></th>
                </tr>
            </thead>
            <tbody>
              {attendanceList.map(attendance=>
                <tr key={attendance.id} className={attendance.updatedBy !== null ? 'table-danger':""}>
                  <td><Link to={"/attendance/employee/"+attendance.employeeId}> {getDDDataById(employeeDD,attendance.employeeId).label} </Link></td>
                  <td>{moment(attendance.inTime).format("LLL")}</td>
                  <td>{attendance.outTime ?
                          moment(attendance.outTime).format("LLL")
                          :
                          "----------"
                      }
                  </td>
                  <td>
                    <CalculateHours inTime={attendance.inTime} outTime={attendance.outTime} />         
                  </td>
                  <td>
                    <UpdatePunchForm data={attendance} callBack={getAttendanceByDate} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        }
      </div>
    </div>
  )
}

export default DailyAttendanceList